import { useEffect } from 'react';
import { ClipStore } from '../types';

interface UseFullscreenEventsParams {
  store: ClipStore;
}

export const useFullscreenEvents = ({ store }: UseFullscreenEventsParams) => {
  useEffect(() => {
    const handleFullscreenChange = () => {
      store.setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, [store]);
};
